import React from 'react'
import PropTypes  from 'prop-types'
export default function About(props) {
    return (
        <div className='container text-center'>
            <div className={`card mw mx-auto mb-3 ${props.mode==='light'?'bgw':'bgb'}`}>
            <h1 className="mg">About us</h1>
                <div className="row g-0">
                    <div className="col-md-4">
                        <img src="hm.jpg" className="img-fluid rounded-start" alt="..."/>
                    </div>
                <div className="col-md-8 align-self-center">
                <div className="card-body">
                    <h1 className="card-title">HI! I am Nosherwan</h1>
                    <p className="card-text">Your web solutunist who can help your create multiple react apps like twitter facebook etc, also have some expertises in MERN Stack web Developments.</p>
                     <p className="card-text"><small className="text-muted">Last updated 3 mins ago</small></p>
                </div>
            </div>
         </div>
    </div>
    </div>
    )
}

